import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  UntypedFormControl,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { Security } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import { PledgeProductRead } from '../../definition/interface/Pledge';
import FormGroupArray from '../../services/FormGroupArray';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }) {
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        avOptionInvestissementProgressif: new UntypedFormControl({
          value: !!entity?.parameters?.avOptionInvestissementProgressif,
          disabled:
            entity?.parameters?.avOptionReequilibrageAutomatique ||
            entity?.parameters?.avOptionSecurisationPlusValues ||
            entity?.parameters?.avOptionLimitationMoinsValuesRelatives,
        }),
        avOptionSecurisationPlusValues: new UntypedFormControl({
          value: !!entity?.parameters?.avOptionSecurisationPlusValues,
          disabled:
            entity?.parameters?.avOptionInvestissementProgressif ||
            entity?.parameters?.avOptionReequilibrageAutomatique,
        }),

        avOptionLimitationMoinsValuesRelatives: new UntypedFormControl({
          value: !!entity?.parameters?.avOptionLimitationMoinsValuesRelatives,
          disabled:
            entity?.parameters?.avOptionInvestissementProgressif ||
            entity?.parameters?.avOptionReequilibrageAutomatique,
        }),
        avOptionReequilibrageAutomatique: new UntypedFormControl({
          value: !!entity?.parameters?.avOptionReequilibrageAutomatique,
          disabled:
            entity?.parameters?.avOptionInvestissementProgressif ||
            entity?.parameters?.avOptionSecurisationPlusValues ||
            entity?.parameters?.avOptionLimitationMoinsValuesRelatives,
        }),
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: Security[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  extract() {
    const products = this.form.value.products;
    // loop through products using map
    const productsList = products.map(product => ({
      ...product,
      parameters: {
        ...product.parameters,
        // check if the value is true or false
        avOptionInvestissementProgressif:
          product.parameters.avOptionInvestissementProgressif || false,
        avOptionSecurisationPlusValues:
          product.parameters.avOptionSecurisationPlusValues || false,
        avOptionLimitationMoinsValuesRelatives:
          product.parameters.avOptionLimitationMoinsValuesRelatives || false,
        avOptionReequilibrageAutomatique:
          product.parameters.avOptionReequilibrageAutomatique || false,
      },
    }));

    return productsList;
  }
}
